import React, { useState } from 'react';
import Img from 'img';
import Button from 'button';
import Icon from 'icon';
import Swiper from 'react-id-swiper';
import Miscellaneous from 'shared/hero-miscellaneous';
import Headline from 'headline';
import { useHeroImage } from '../../../hooks/useHeroImage';
import 'swiper/dist/css/swiper.css';
import s from './hero-slider.module.scss';

export default function HeroSlider({ slides, ...props }) {
  const [swiper, updateSwiper] = useState(null);

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  const params = {
    preloadImages: false,
    autoplay: {
      delay: 5000
    }
  };

  const { heroImage } = useHeroImage({ slides });

  return (
    <section className={s.root}>
      <div className={s.prev} onClick={goPrev}>
        <Icon icon="slider-prev" />
      </div>
      <div className={s.next} onClick={goNext}>
        <Icon icon="slider-next" />
      </div>
      <Swiper getSwiper={updateSwiper} {...params}>
        {slides.map(({ image, title, paragraph, button }, i) => (
          <div className={s.wrapper} key={image.title}>
            <div className={s.imgWrapper}>
              <Img
                className={s.img}
                src={heroImage[i]}
                alt={heroImage[i]?.title}
              />
            </div>
            <div className={`container ${s.content}`}>
              {title && (
                <Headline className={s.title} center h1 white html={title} />
              )}
              {paragraph && (
                <p
                  className={s.text}
                  dangerouslySetInnerHTML={{ __html: paragraph }}
                />
              )}
              <Miscellaneous />
              {button.text && (
                <Button className={s.button} href={button.href || '#'}>
                  {button.text}
                </Button>
              )}
            </div>
          </div>
        ))}
      </Swiper>
    </section>
  );
}
